import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import { useContentDatabaseContextValue } from "#content-database-context-value";

export type ContentDatabaseContextValue = ReturnType<typeof useContentDatabaseContextValue>;

export const ContentDatabaseContext = createContext(
  defaultError<ContentDatabaseContextValue>("ContentDatabaseContext"),
);
